import React, { Component } from "react";
import { motion } from "framer-motion";
import InfoCard from "../Components/InfoCard";
import ImageGallery from "../Components/ImageGalleryThreeCol";

import kimphotos from "../Assets/img/bio.png";
import cave from "../Assets/img/about/cave.jpg";
import painting from "../Assets/img/about/painting.jpg";
import climbing from "../Assets/img/about/climbing.jpg";
import camp from "../Assets/img/about/camp.jpg";
import hike from "../Assets/img/about/hike.jpg";
import working from "../Assets/img/about/IMG_7061.JPG";
import Resume from "../Assets/kimbicknese-resume.pdf";

class About extends Component {
  render() {
    return (
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ y: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.75, ease: "easeOut" }}
      >
        <div className="container">
          <section>
            <div className="row middle-sm">
              <div className="col-md-6 pr-lg">
                <p className="lead">
                  Hi, I'm Kim! 👋 I'm a product designer and artist based in
                  Atlanta, GA with a passion for creating intuitive experiences.
                </p>
                <p className="lead">
                  I’ve spent the last 10+ years designing digital products from
                  0-1 products for early startups to established B2B/B2B2C SaaS
                  platforms. I blend data-driven insights, research, front-end
                  code knowledge, and empathy to create impactful experiences
                  with real business impact.
                </p>
              </div>
              <div
                className="col-md-6 card"
                style={{
                  backgroundImage: `url(${working})`,
                  height: "400px",
                  backgroundSize: "cover", // Optional: makes image cover the div
                  backgroundPosition: "center", // Optional: centers the image
                }}
              ></div>
            </div>
            <h4>My skillset</h4>
            <p>
              <span className="chip large">End-to-end product design</span>
              <span className="chip large">Rapid prototyping</span>
              <span className="chip large">
                AI prototyping (v0, Lovable, Figma Make)
              </span>
              <span className="chip large">Claude Code</span>
              <span className="chip large">Front-end development</span>
              <span className="chip large">0-1 products</span>
              <span className="chip large">AI-powered products</span>
              <span className="chip large">Custom front-end frameworks</span>
              <span className="chip large">Mobile app & responsive design</span>
              <span className="chip large">Design systems</span>
              <span className="chip large">UX research</span>
              <span className="chip large">Usability testing</span>
              <span className="chip large">A/B testing</span>
              <span className="chip large">Design strategy </span>
              <span className="chip large">Collaboration</span>
            </p>
          </section>

          <section>
            <h2>Design principles</h2>
            <div className="row middle-sm">
              <div className="col-md-4 pr-lg">
                <div className="row">
                  <p className="lead">
                    I thrive in both autonomous and collaborative environments,
                    digging deep to uncover root problems before designing
                    solutions.
                  </p>
                  {/* <p className="lead">
                    I bring a systems mindset grounded in research and fluency
                    in code while balancing business impact — ensuring the
                    experiences I design are thoughtful, feasible, and
                    measurable.
                  </p> */}
                </div>
              </div>
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-6" style={{ display: "flex" }}>
                    <InfoCard
                      style="#FEECF9"
                      title="🧒 Design for real people."
                      content={[
                        "Understand their needs, behaviors, pain points, and goals.",
                      ]}
                    />
                  </div>
                  <div className="col-md-6" style={{ display: "flex" }}>
                    <InfoCard
                      style="#E8F6FF"
                      title="🌱 Think long-term, design sustainably."
                      content={[
                        "What you build should endure and adapt, allowing for future scalability.",
                      ]}
                    />
                  </div>
                  <div className="col-md-6" style={{ display: "flex" }}>
                    <InfoCard
                      style="#DFDDF9"
                      title="✅ Be predictable in the right ways."
                      content={[
                        "Familiar patterns reduce cognitive load and deliver a more cohesive user experience.",
                      ]}
                    />
                  </div>
                  <div className="col-md-6" style={{ display: "flex" }}>
                    <InfoCard
                      style="#EAF6D5"
                      title="🧪 Don’t wait for perfect—test and evolve."
                      content={[
                        "Good design is born from continuous testing and iteration. Failure is essential in learning what works and what doesn’t!",
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* <section>
            <h2>Experience</h2>
            <InfoCard
              style="#FEECF9"
              title="Popmenu"
              content={[
                "**Senior Product Designer, Dec 2022 - Present**",
                "*Product Designer, Nov 2020 - Dec 2022*",
                "At Popmenu, I’ve led end-to-end design for key initiatives, including an AI-powered reputation management tool that increased review responses and a new website builder that enabled client self-service and reduced support needs. I partner closely with product, engineering, and research to uncover pain points, run testing, and shape the roadmap, and I maintain our Figma design system to ensure consistency across teams.",
              ]}
            />
            <InfoCard
              style="#FEECF9"
              title="CINC"
              content={[
                "**Senior Product Designer, Dec 2022 - Present**",
                "*Product Designer, Nov 2020 - Dec 2022*",
                "At Popmenu, I’ve led end-to-end design for key initiatives, including an AI-powered reputation management tool that increased review responses and a new website builder that enabled client self-service and reduced support needs. I partner closely with product, engineering, and research to uncover pain points, run testing, and shape the roadmap, and I maintain our Figma design system to ensure consistency across teams.",
              ]}
            />
          </section> */}

          <section className="section teal">
            <div className="row">
              <div className="col-md-6 pr-lg">
                <h2>Outside of work, I have a lot of hobbies!</h2>
                <p>
                  I enjoy bouncing between my many hobbies which include oil
                  painting 🎨, crocheting 🧶, learning Japanese 🇯🇵, rock
                  climbing 🧗‍♀️, hiking 🏔, muay thai 🥊, scuba diving 🤿, and
                  traveling the world with my husband ✈️.
                </p>
                <p>
                  In 2022, I decided to put more effort into my oil paintings
                  and have participated in several fine art shows around
                  Atlanta. If you want to learn more about my art,{" "}
                  <a href="https://kimbickneseart.com" target="_blank">
                    feel free to head over to my portfolio.
                  </a>{" "}
                </p>
              </div>
              <div
                className="col-md-6 card"
                style={{
                  backgroundImage: `url(${cave})`,
                  height: "400px",
                  backgroundSize: "cover", // Optional: makes image cover the div
                  backgroundPosition: "center", // Optional: centers the image
                }}
              >
                <div className="chip white">
                  Caving in Hang Sơn Đoòng, Vietnam
                </div>
              </div>
            </div>

            <ImageGallery
              images={[
                { src: painting, caption: "Working on a painting" },
                { src: camp, caption: "Camping at Yonah Mountain, GA" },
                { src: climbing, caption: "Climbing at Sand Rock, AL" },
              ]}
              height="300px"
              gap="16px"
            />
            {/* <div className="row">
            <div className="col-md-4">
              <div
                className="card"
                style={{
                  backgroundImage: `url(${painting})`,
                  height: "400px",
                  backgroundSize: "cover", // Optional: makes image cover the div
                  backgroundPosition: "center", // Optional: centers the image
                }}
              >
                <div className="chip white">Working on a painting</div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="card"
                style={{
                  backgroundImage: `url(${climbing})`,
                  height: "400px",
                  backgroundSize: "cover", // Optional: makes image cover the div
                  backgroundPosition: "center", // Optional: centers the image
                }}
              >
                <div className="chip white">Climbing at Sand Rock, AL</div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="card"
                style={{
                  backgroundImage: `url(${camp})`,
                  height: "400px",
                  backgroundSize: "cover", // Optional: makes image cover the div
                  backgroundPosition: "center", // Optional: centers the image
                }}
              >
                <div className="chip white">Camping at Yonah Mountain, GA</div>
              </div>
            </div>
          </div> */}
          </section>
          {/* <div className="container-short">
          <h2>Hi, I'm Kim!</h2>

          <p>
            I'm a product designer and artist based in Atlanta, GA with a
            passion for creating delightful experiences. Since I was young, I've
            had a love for design and fine arts. I always dreamed of having some
            sort of creative career, so it's exciting that I can help users
            navigate the digital world through the experiences I craft.
          </p>

          <p>
            In addition to product design, I love exploring the world of code
            every now and then. I first learned the wonders of HTML/CSS back in
            the days of Myspace and it morphed into me building websites as a
            hobby. I'm proud to say that this portfolio was created with
            ReactJS. Updating this certainly keeps me on my toes with code!
          </p>

          <p>
            Outside of the office, I enjoy bouncing between my many hobbies
            which include oil painting, rock climbing, hiking, muay thai,
            photography, scuba diving, and traveling the world with my husband.
            In 2022, I decided to put more effort into my oil paintings and have
            participated in several fine art shows around Atlanta. If you want
            to learn more about my art,{" "}
            <a href="https://kimbickneseart.com" target="_blank">
              feel free to head over to my portfolio.
            </a>{" "}
          </p>

          {/* <p>Interested in learning more about my experience? <a href={Resume} target="_blank">Here's my resume.</a></p> 
        </div> */}

          {/* <div class="container">
          <br />
          <img className="img-shadow" src={kimphotos} width="100%" />
          <br />
        </div> */}
        </div>
      </motion.div>
    );
  }
}

export default About;
